import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageModule } from './pages/home/home.module';
import { HomePageComponent } from './pages/home/home.page';

const routes: Routes = [
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }), HomePageModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
